import axios from 'axios'
import router from '../router'
// import {Message} from 'element-ui';

// 添加一个标记，防止重复跳转
let isRedirecting = false;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = "../"

// 请求拦截器
axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('sessionId');
  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
})

// 响应拦截器
axios.interceptors.response.use((response) => {
  // console.log('axios.interceptors.response=====================> ', response);
  if (response.status === 200) {
    // 检查业务状态码
    if (response.data && response.data.code == 401) {
      handleUnauthorized();
      return Promise.reject(response)
    }
    return Promise.resolve(response)
  } else {
    return Promise.reject(response)
  }
}, error => {
  if (error.response && error.response.status) {
    switch (error.response.status) {
      case 401:
        handleUnauthorized();
        break;
      default:
        // Message.error({
        //   message: error.response.statusText || '请求失败'
        // })
        console.log(error.response.statusText || '请求失败')
    }
    return Promise.reject(error.response);
  }
  return Promise.reject(error);
})

// 统一处理未授权
function handleUnauthorized() {
  // 如果已经在跳转中，就不再重复跳转
  if (isRedirecting) {
    return;
  }

  isRedirecting = true;
  window.localStorage.clear();

  // 获取当前路由路径
  const currentPath = router.currentRoute.path;

  // 如果不在登录页，才跳转
  if (currentPath !== '/login') {
    router.push({
      path: '/login',
      query: {redirect: currentPath} // 可选的：记录要重定向的页面
    }).catch(err => {
      // 忽略导航错误
      console.log('Navigation error:', err.message);
    }).finally(() => {
      // 延迟重置标记，避免短时间内多次触发
      setTimeout(() => {
        isRedirecting = false;
      }, 1000);
    });
  } else {
    // 如果在登录页，直接重置标记
    isRedirecting = false;
  }
}

// 封装请求方法
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params})
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, JSON.stringify(data))
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/common/axios.js